/**
 * When a piece is already selected, clicking another own piece must switch
 * selection (Lichess/chess.com) — never treat that square as a move target.
 * Own pieces are never legal destinations, so this cannot steal a capture.
 *
 * @returns {{ action: 'select', square: string, optionSquares: object }|{ action: 'clear' }|null}
 */
export function resolveOwnPieceRetarget({
  chess,
  moveFrom,
  square,
  ownColor,
  buildOptions,
}) {
  if (!moveFrom || !square || moveFrom === square) return null;
  const piece = chess.get(square);
  if (!piece || piece.color !== ownColor) return null;
  const next = buildOptions(chess, square);
  if (next) return { action: 'select', square, optionSquares: next };
  return { action: 'clear' };
}
